import { render, staticRenderFns } from "./examSidebar.vue?vue&type=template&id=30b35cfc&scoped=true"
import script from "./examSidebar.vue?vue&type=script&lang=js"
export * from "./examSidebar.vue?vue&type=script&lang=js"
import style0 from "./examSidebar.vue?vue&type=style&index=0&id=30b35cfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b35cfc",
  null
  
)

export default component.exports